import React from "react";
import { Button } from "@mui/material";

interface FpButtonProps {
  variant?: "contained" | "outlined" | "text";
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const FpButton = ({ children, ...props }: FpButtonProps) => {
  return (
    <Button
      {...props}
      sx={{ textTransform: "none" }}
      className="h-fit w-fit"
      variant={props.variant || "contained"}
      style={{
        fontSize: "10px",
        padding: "2px",
        backgroundColor: "white",
        ...props.style,
      }}
      disabled={props.disabled}
    >
      {children}
    </Button>
  );
};

export default FpButton;
